export default __webpack_public_path__ + "static/media/CW.40e4f500.svg";